import React from "react";

import {LeadModel} from "@/typings/models/Lead";
import PrettyDate from "@/components/PrettyDate";

import styles from "./index.less"
import {F} from "@/utils/intl";

const LeadAppointmentAt = ({lead, isTable}: {lead: LeadModel, isTable?: boolean}) => {
  if (!lead.latest_appointment) return <div> - </div>
  const content = <PrettyDate absolute date={lead.latest_appointment.when}/>

  if (isTable) return content

  return <div>
    <div className={styles.tinyDateKey}><F id={"pages.lead.fields.appointmentAt"} defaultMessage={"Latest Appointment"}/></div>
    <div><PrettyDate absolute date={lead.latest_appointment.when}/></div>
  </div>

}

export default LeadAppointmentAt
